
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.556 9.777L12 5.333l4.424 4.424 2.667-2.666-4.424-4.424L12 0 9.333 2.667 4.89 7.11l2.666 2.667zm13.757-.464L18.667 12l2.666 2.667L24 12l-2.687-2.687zM12 18.667l4.424-4.424 2.667 2.666-4.424 4.424L12 24l-2.667-2.667L4.89 16.89l2.666-2.667L12 18.667zm-6.666-6.668L2.667 9.333 0 12l2.667 2.667L5.334 12v-.002zm9.332 0L12 9.333 9.332 12 12 14.667 14.666 12v-.002z","fill":"#F3BA2F"}})])
          )
        }
      }
    